exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body[data-v-ffb9d4ca] {\n  min-height: 200px;\n}\n.md-helper-text-datepicker[data-v-ffb9d4ca] {\n  color: #ff5245;\n  margin-left: 36px;\n  font-size: 12px;\n  -webkit-transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n", ""]);

// exports
